import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Offsite Excursion' },
    { value: 2, label: 'In School' },
    { value: 3, label: 'Fundraising' },
    { value: 4, label: 'Social' },
    { value: 5, label: 'Sporting' },
    { value: 6, label: 'Cultural' },
    { value: 7, label: 'Assembly' },
    { value: 8, label: 'Staff Meeting' },
    { value: 9, label: 'Student Event' },
    //{ value: 10, label: 'Teaching Session' }, Hidden until we integrate units
    { value: 11, label: 'Custom' },
  ],
});
